import AbstractDeclarantStore from "./AbstractDeclarantStore";
import ee from "../services/EventEmitter";
import { DELETE_CREATED_EVENT } from "../constants/events";

class UsersDeclarantsStore extends AbstractDeclarantStore {
  init() {
    ee.on(DELETE_CREATED_EVENT, (id) => {
      this.deleteEntity(id);
    });
  }

  protected getDeclarants(): Promise<Response> {
    return this.apiManager.getDeclarantsByUsers(this._parameters);
  }
}

export default UsersDeclarantsStore;
